<style lang="less" scoped>

</style>

<template>
    <div>
        <h2 class="pageTitle">管理員列表</h2>

        <!-- 搜索Box -->
        <div class="sb searchBoxWrap">
            <div class="al">
                <Input type="text" v-model="keyword" clearable @on-clear="search" @on-keydown.enter="search" /> 
                <Button type="primary" class="searchBtn" @click="search">搜索</Button>
            </div>
            <div>
                <Button type="info" @click="showAdd=true">+ 創建新管理員</Button>
            </div>
        </div>

        <div class="tableWrap">
            <Table :columns="columns" :data="list" :searchable="false" border :loading="tableLoad">
                <template slot="action" slot-scope="{row}">
                    <div class="ju">
                        <Button type="warning" size='small' style="margin-right: 10px;" @click="edit(row)">編輯</Button>
                        <Button type="error" size='small' @click="del(row)">刪除</Button>
                    </div>
                </template>

                <template slot="position" slot-scope="{row}">
                    <div>{{ position_list.find(p => p.id== row.role_id) ? position_list.find(p => p.id== row.role_id).role : "" }}</div>
                </template>
            </Table>
        </div>

        <div class="PageWrap">
            <Page :current="page" :page-size="offset" :total="total" @on-change="changePage"></Page>
        </div>

        <!-- 創建 -->
        <Modal v-model="showAdd">
            <div slot="header" class="ModalHeader">
                <div>創建新管理員</div>
            </div>

            <div>
                <Form :model="addForm" :rules="rules" :label-width="130" ref="addForm">
                    <FormItem prop="username" label="管理員">
                        <Input v-model="addForm.username" style="width:250px" @on-keydown.enter="okAdd" />
                    </FormItem>
                    <FormItem prop="password" label="密碼">
                        <Input v-model="addForm.password" style="width:250px" @on-keydown.enter="okAdd" type="password" />
                    </FormItem>
                    <FormItem prop="role_id" label="職位">
                        <Select style="width: 250px;" v-model="addForm.role_id">
                            <Option v-for="(item) in position_list" :key="item.id" :value="item.id">{{item.role}}</Option>
                        </Select>
                    </FormItem>
                </Form>
            </div>

            <div slot="footer" class="ju ModalBtn">
                <Button type="error" size="small" @click="showAdd=false">取消</Button>
                <Button type="info" size="small" @click="okAdd" :loading="load">+ 創建</Button>
            </div>
        </Modal>

        <Modal v-model="showEdit">
            <div slot="header" class="ModalHeader">
                <div>編輯管理員</div>
            </div>

            <div>
                <Form :model="editForm" :rules="rules" :label-width="130" ref="editForm">
                    <FormItem prop="username" label="管理員">
                        <Input v-model="editForm.username" style="width:250px" @on-keydown.enter="okEdit" />
                    </FormItem>
                    <FormItem prop="password" label="密碼">
                        <Input v-model="editForm.password" style="width:250px" @on-keydown.enter="okEdit" type="password" />
                    </FormItem>
                    <FormItem prop="role_id" label="職位">
                        <Select style="width: 250px;" v-model="editForm.role_id">
                            <Option v-for="(item) in position_list" :key="item.id" :value="item.id">{{item.role}}</Option>
                        </Select>
                    </FormItem>
                </Form>
            </div>

            <div slot="footer" class="ju ModalBtn">
                <Button type="error" size="small" @click="showEdit=false">取消</Button>
                <Button type="info" size="small" @click="okEdit" :loading="load">編輯</Button>
            </div>
        </Modal>


    </div>
</template>

<script>
export default {
    data () {
        return {
            columns: [
                { title: "編號", key: "id", sortable: true, align:"center", width: 100 },
                { title: "賬號", key: "username", sortable: true, align:"center" },
                { title: "職位", key: "position", sortable: true, align:"center", slot: "position" },
                { title: "創建時間", key: "createAt", sortable: true, align:"center" },
                { title: "操作", slot: "action", align:"center" },
            ],
            list: [ ],
            position_list: [],
            keyword: "",
            page: 1,
            total: 0,
            showAdd: false,
            showEdit: false,
            tableLoad: false,
            addForm: {
                username: "",password: "", role_id: '1'
            },
            editForm: {
                username: "",password: "", role_id: '1'
            },
            rules: {
                username: [
                    { required: "true", message: "請輸入管理員賬號", trigger: "blur" }
                ],
                password: [
                    { required: "true", message: "請輸入密碼", trigger: "blur" }
                ],
                role_id: [
                    { required: "true", message: "請輸入管理員職位", trigger: "blur" }
                ],
            },
            load: false,
        }
    },

    computed: {
        role () { return this.$store.state.role },
        offset () { return this.$store.state.offset },
    },
    created () {
        if (this.role == 2) {
            this.columns.pop()
        }
        this.showTable()
    },
    methods:{
        showTable () {
            this.tableLoad = true
            this.$axios({
                url: "admin/user",
                params: {
                    page: this.page,
                    offset: this.offset,
                    search:this.keyword
                }
            }).then(res => {
                console.log(res)
                if (res.data.data) {
                    this.list = res.data.data.user_list
                    if (res.data.data.position_list) {
                        res.data.data.position_list.forEach(p => {
                            p.id = p.id + ""
                        })
                        this.position_list = res.data.data.position_list
                    }
                    if (res.data.data.user_list.length == 0 && this.page > 1) {
                        this.page--
                        this.showTable()
                    }
                } else {
                    this.list =  []
                    this.position_list = []
                }
                this.tableLoad = false
            }).catch(e => {
                console.log(e)
                this.tableLoad = false
                this.$Message.error("網絡錯誤, 請稍後再試")
            })
        },
        changePage (e) {
            this.page = e
            this.showTable()
        },
        okAdd () {
            let that =this
            this.$refs.addForm.validate(flag => {
                if (flag) {
                    that.load = true
                    that.$axios({
                        url: "admin/user",
                        method:"POST",
                        data: {
                            username: this.addForm.username,
                            password: this.addForm.password,
                            role_id: this.addForm.role_id * 1,
                        }
                    }).then(res => {
                        that.load = false
                        if (res.data.data.msg == '增加成功') {
                            that.$Message.success("創建成功")
                            that.showTable()
                            that.showAdd = false
                            that.$refs.addForm.resetFields()
                        } else {
                            that.$Message.warning(res.data.data.msg)
                        }
                    }).catch(e => {
                        console.log(e)  
                        that.load = false
                        that.$Message.error("網絡錯誤, 請稍後再試")
                    })
                }
            })
        },
        edit (item) {
            this.showEdit = true
            this.editForm.uuid = item.uuid
            this.editForm.username = item.username
            this.editForm.password =  ""
            this.editForm.position = item.position + ""
            this.editForm.role_id = item.role_id + ""
        },
        del (item) {
            let that = this
            that.$Modal.confirm({
                title: '提示',
                content : "確定刪除這條信息?",
                onOk () {
                    that.$axios({
                        url: "admin/user",
                        method:"DELETE",
                        data: {
                            uuid: item.uuid
                        }
                    }).then(res => {
                        that.$Message.success('已刪除')
                        that.showTable()
                    })
                }
            })
        },
        okEdit () {
            let that =this
            this.$refs.editForm.validate(flag => {
                if (flag) {
                    that.load = true
                    that.$axios({
                        url: "admin/user",
                        method:"PUT",
                        data: {
                            uuid: that.editForm.uuid,
                            username: that.editForm.username,
                            password: that.editForm.password,
                            role_id: that.editForm.role_id * 1,
                        }
                    }).then(res => {
                        that.load = false
                        if (res.data.code == 200) {
                            that.$Message.success("編輯成功")
                            that.showTable()
                            that.showEdit = false
                        } else {
                            that.$Message.warning(res.data.data.msg)
                        }
                    }).catch(e => {
                        console.log(e)  
                        that.load = false
                        that.$Message.error("網絡錯誤, 請稍後再試")
                    })
                }
            })
        },
        search () {
            this.page = 1
            this.showTable()
        },
    }
}
</script>

